var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"updates__item"},[_c('div',{staticClass:"updates__item--top"},[_c('h4',[_vm._v(" "+_vm._s(_vm.update.attributes.title)+" ")]),_c('span',[_vm._v(_vm._s(_vm.ago))])]),_c('p',[_vm._v(" "+_vm._s(_vm.update.attributes.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }